import React, { useRef } from 'react';
import { Box } from '@mui/material';
import { type ResizeHandleAxis } from 'react-grid-layout';
import ReactGridContainer from '../ReactGridContainer/ReactGridContainer';

type ReactGridContainerWithChildrensProps = {
    localStorageName: string;
    childrens: { key: string; component: React.ReactNode }[];
    maxIndexCard?: number;
    rowHeight?: number;
    cols?: number;
};

const ReactGridContainerWithChildrens: React.FunctionComponent<ReactGridContainerWithChildrensProps> =
    function ({ localStorageName, childrens, maxIndexCard = 5, rowHeight = 250, cols = 5 }) {
        const maxXindexCard = maxIndexCard;
        const currentXIndexCard = useRef(-1);
        const currentYIndexCard = useRef(0);

        return (
            <ReactGridContainer
                localStorageName={localStorageName}
                gridconfig={{ cols, rowHeight }}
                layoutProps={[
                    ...childrens.map((widget, i) => {
                        if (i !== 0 && i % maxXindexCard === 0) {
                            currentXIndexCard.current = -1;
                            currentYIndexCard.current++;
                        }
                        currentXIndexCard.current++;
                        return {
                            i: widget.key,
                            x: currentXIndexCard.current,
                            y: currentYIndexCard.current,
                            w: 1,
                            h: 1,
                            isResizable: true,
                            resizeHandles: [
                                's',
                                'w',
                                'e',
                                'n',
                                'sw',
                                'nw',
                                'se',
                                'ne',
                            ] as ResizeHandleAxis[],
                        };
                    }),
                ]}
            >
                {childrens &&
                    childrens.map((widget) => (
                        <Box key={widget!.key as string}>{widget.component}</Box>
                    ))}
            </ReactGridContainer>
        );
    };

export default ReactGridContainerWithChildrens;
